module.exports = __webpack_public_path__ + "img/114-british-virgin-islands.cb98f184.svg";